import React, { Component } from "react";
import { connect } from "react-redux";
import { setCurrentCase } from "../actions/cases";
import SecondCaseFileScreen from "../component/SecondCaseFileScreen";
import DefaultFileScreen from "../component/DefaultFileScreen";
import "../assets/css/FileScreen.css";

class FileScreen extends Component {
  constructor(props) {
    super(props);
    this.state = {
      modal: false,
      hidden: true
    };
  }

  componentDidMount() {
    if (this.props.currentCase != null) this.setState({ hidden: false });
  }

  deleteCurrentCase() {
    this.props.cases[this.props.currentSelection.kind].splice(
      this.props.currentSelection.case,
      1
    );
    this.props.setCurrentCase(null);
    this.setState({ hidden: true });
    this.forceUpdate();
  }

  closeCurrentCase() {
    this.props.setCurrentCase(null);
    this.setState({ hidden: true });
    this.forceUpdate();
  }

  isHidden() {
    return this.state.hidden ? " hidden" : "";
  }

  isNowHidden() {
    return !this.state.hidden ? " hidden" : "";
  }

  toggleTabs(val) {
    this.setState({ hidden: val });
  }

  renderCase() {
    // console.log(this.state)
    if (this.props.currentCase == null) return null;
    return (
      <div className={"caseTab" + this.isHidden()}>
        <SecondCaseFileScreen
          case={this.props.currentCase}
          close={this.closeCurrentCase.bind(this)}
          delete={this.deleteCurrentCase.bind(this)}
          addEntry={this.addLogEntry.bind(this)}
        />
        {/* <p>CURRENT CASE</p>
        <p>{this.props.currentCase.name}</p>
        <button onClick={() => this.deleteCurrentCase()}>Close Case</button> */}
      </div>
    );
  }

  addLogEntry() {
    //let curDate = new Date().getDate() + '.' + new Date().getMonth() + '.' + new Date().getFullYear();
    let entry = {
      date: "14.06.2018",
      status: "Crefo",
      state: "Übergeben",
      worker: "M. Müller",
      action: "Email",
      money: "830",
      change: "•"
    };
    this.props.cases[this.props.currentSelection.kind][
      this.props.currentSelection.case
    ].logs.splice(0, 0, entry);
    // console.log(this.props.cases);
  }

  renderButton() {
    if (this.props.currentCase != null) {
      return (
        <button
          onClick={() => this.toggleTabs(false)}
          className={!this.state.hidden ? "active" : ""}
        >
          {this.props.currentCase.id}
        </button>
      );
    }
  }

  render() {
    return (
      <div className="fileScreen">
        <div className="tabRow">
          <button
            onClick={() => this.toggleTabs(true)}
            className={this.state.hidden ? "active" : ""}
          >
            Alle Fälle
          </button>
          {this.renderButton()}
        </div>
        <div className={"defaultTab" + this.isNowHidden()}>
          <DefaultFileScreen />
        </div>
        {this.renderCase()}
      </div>
    );
  }
}

const mapStateToProps = state => {
  return {
    cases: state.cases,
    currentCase: state.currentCase,
    currentSelection: state.currentSelection
  };
};

const mapDispatchToProps = dispatch => ({
  setCurrentCase: curCase => {
    dispatch(setCurrentCase(curCase));
  }
});

export default connect(mapStateToProps, mapDispatchToProps)(FileScreen);



// WEBPACK FOOTER //
// ./src/screens/FileScreen.js